import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  token: null,
  expiry: null,
};

// Local storeage
export const fetchToken = createAsyncThunk(
  "authToken/fetchToken",
  async () => {
    // ...
  }
  // async (_, thunkAPI) => {
  //   const response = {
  //     data:{
  //       count: 1
  //     }
  //   }
  //   return response.data;
  // }
);

// Create slice
const authTokenSlice = createSlice({
  name: 'authToken',
  initialState,
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload.token;
      state.expiry = action.payload.expiry;
    }
  },
  // extraReducers: {
  //   [fetchCount.fulfilled]: (state, action) => {
  //     state.count = action.payload;
  //   },
  // },
  extraReducers: (builder) => {
    // fulfilled, pending, rejected
    builder.addCase(fetchToken.fulfilled, (state, action) => {
      state.token = action.payload.token;
      state.expiry = action.payload.expiry;
    })
  },
  
});

// Actions & Reducer
// export const { increment, decrement } = counterSlice.actions;
export const authTokenActions = authTokenSlice.actions;

export default authTokenSlice;
